import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface LogoutConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onConfirm: () => void;
  isLoading?: boolean;
}

export default function LogoutConfirmationModal({
  open,
  onClose,
  setOpen,
  onConfirm,
  isLoading = false,
}: LogoutConfirmationModalProps) {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleClose = () => {
    if (!isLoading) {
      setOpen(false);
      onClose();
    }
  };

  return (
    <Modal
      className="modal deleteConfirmation_modal"
      open={open}
      onClose={handleClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Logout Confirmation</h2>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
              disabled={isLoading}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="mb_20 hd_6">
            <h3>Are you sure you want to logout?</h3>
            <p>You will need to login again to access your account.</p>
          </div>

          <div className="footer_btn_flex">
            <Button
              className="btn btn_grey"
              onClick={handleClose}
              disabled={isLoading}
            >
              No
            </Button>
            <Button
              className="btn btn_primary"
              onClick={handleConfirm}
              disabled={isLoading}
            >
              {isLoading ? "Logging out..." : "Yes"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

